import { render, staticRenderFns } from "./inline-loader.vue?vue&type=template&id=5cf77ec8"
import script from "./inline-loader.vue?vue&type=script&lang=js"
export * from "./inline-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cf77ec8')) {
      api.createRecord('5cf77ec8', component.options)
    } else {
      api.reload('5cf77ec8', component.options)
    }
    module.hot.accept("./inline-loader.vue?vue&type=template&id=5cf77ec8", function () {
      api.rerender('5cf77ec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/general/inline-loader.vue"
export default component.exports